import React from "react";

import { StatusBadge } from "@/components/ui";
import type { AdminSeller } from "@/hooks/useAdminSeller";
import { cn, titleCase } from "@/lib/utils";

import { planColors, workspaceStatusBadge } from "./seller.constants";

export const SellerHeaderBadges: React.FC<{ seller: AdminSeller }> = ({
  seller,
}) => (
  <div className="fade-in flex items-center gap-3 mb-6">
    <span
      className={cn(
        "px-2.5 py-1 text-xs font-semibold rounded-full border",
        planColors[seller.plan] ?? planColors.FREE,
      )}
    >
      {titleCase(seller.plan)}
    </span>
    <StatusBadge status={workspaceStatusBadge[seller.status] ?? seller.status}>
      {titleCase(seller.status)}
    </StatusBadge>
    {seller.marketplaces.map((m) => (
      <span
        key={m}
        className="px-2 py-0.5 text-[10px] font-medium rounded bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400"
      >
        {titleCase(m)}
      </span>
    ))}
  </div>
);
